import React from 'react';
import PropTypes from 'prop-types';
import toast, { Toaster } from 'react-hot-toast';

export const TOAST_POSITION = {
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-righ',
};

export const TOAST_DIRECTION = {
  NEW_FIRST: false,
  OLD_FIRST: true,
};

const Toast = ({position = TOAST_POSITION.TOP_CENTER, direction = TOAST_DIRECTION.OLD_FIRST}) => {
  return (
    <>
      <Toaster
        position={position}
        reverseOrder={direction}
        toastOptions={{
          duration: 5000,
          removeDelay: 1000,
        }}
      />
    </>
  );
}

Toast.propTypes = {
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  title: PropTypes.string,
  confirmation: PropTypes.string,
  show: PropTypes.bool,
  proceed: PropTypes.func,
  enableEscape: PropTypes.bool,
}

export const notify = toast;

export default Toast;